module.exports = __webpack_public_path__ + "static/reactjs-bf6e7aa4366ba93442e42038897d683d.png";